import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  bandwidthList: [],
  account:null,
  bandwidth: null,
  error: false,
  loading: false,
  loaded:false,
  realBandwidth:null,
  days:7
};
const resetBandwidthState = (state, action) => {
  return updateObject(state, initialState)
}
const initBandwidthStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded:false,
    days:action.days
  });
};

const setBandwidth = (state, action) => {
  return updateObject(state, {
    realBandwidth: action.realBandwidth,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchBandwidthFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    loaded: true,
    error: true
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_BANDWIDTH_START:
      return initBandwidthStart(state, action);
    case actionTypes.SET_BANDWIDTH:
      return setBandwidth(state, action);
    case actionTypes.FETCH_BANDWIDTH_FAILED:
      return fetchBandwidthFailed(state, action);
    default:
      return state;
  }
};

export default reducer;
